/**
 * v-permission 指令：根据当前管理员权限控制元素显隐。
 *
 * 用法：
 *   <el-button v-permission="'page:users'">编辑</el-button>
 *   <el-button v-permission="['page:users', 'page:roles']">管理</el-button>
 *
 * 行为：
 * - 超管：始终显示
 * - 有权限：显示
 * - 无权限：从 DOM 移除
 */
import type { Directive, DirectiveBinding } from 'vue'
import { useUserStore } from '@/store/user'

function check(el: HTMLElement, binding: DirectiveBinding<unknown>) {
  const userStore = useUserStore()
  const value = binding.value

  // 没传值 → 显示
  if (value === undefined || value === null || value === '') return

  const ok = Array.isArray(value)
    ? userStore.hasPermission(value)
    : userStore.hasPermission(String(value))

  if (!ok) {
    el.parentNode?.removeChild(el)
  }
}

export const permissionDirective: Directive = {
  mounted(el, binding) {
    check(el, binding)
  },
  updated(el, binding) {
    // 权限变更后（重新登录）重新检查
    check(el, binding)
  }
}